import React from "react";
import { Redirect, Route, useRouteMatch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import ParentWrapper from "../../components/ParentWrapper";
import PrivateRoute from "../../components/PrivateRoute";
import UserAppManager from "../../../src/pages/UserAppManager";
import PendingAccession from "../PendingAccession/PendingAccession";
import DataUpdation from "./AF2DataUpdation/DataUpdation";
import LVDataUpdation from "./AF2DataUpdation/LVDataUpdation";
import InterfaceManager from "./DataInterfaceManager/InterfaceManager";
import ClientSamplesPendingAccessioning from "../PendingAccession/Client-Samples-Pending-Accessioning";
const queryClient = new QueryClient();

const ParentConsole = () => {
  let { path } = useRouteMatch();
  return (
    <QueryClientProvider client={queryClient}>
      <ParentWrapper path={path}>
        <PrivateRoute exact path={`${path}/internal-pending-accession`}>
          <PendingAccession />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/external-pending-accession`}>
          <ClientSamplesPendingAccessioning />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/data-updation`}>
          <DataUpdation />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/lv-data-updation`}>
          <LVDataUpdation />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/data-interface-manager`}>
          <InterfaceManager />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/users`}>
          <UserAppManager service={`${path}`} />
        </PrivateRoute>
        <Route>
          <Redirect to={`${path}/internal-pending-accession`} />
        </Route>
      </ParentWrapper>
    </QueryClientProvider>
  );
};

export default ParentConsole;
